import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { BaseContext } from '../../../../utils/basecontext';
import { GET, APIImpl } from '../../api';
import { BannerSearchRequest } from './bannersearchrequest';

export class BannerSearchAPI extends APIImpl<BannerSearchRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/banner-search
        return "banner-search"+"?"+"searchKey=" + this.getRequest().getBannerSearchRequest().getSearchKey() +"&"+
        "language="+ this.getRequest().getBannerSearchRequest().getLanguage() +"&"+
        "type="+ this.getRequest().getBannerSearchRequest().getType() +"&"+
        "pageNo="+ this.getRequest().getBannerSearchRequest().getPageNumber() +"&"+
        "pagePerCount="+ this.getRequest().getBannerSearchRequest().getPagePerCount();
    }

    /* getRequestData()
    {
        return "searchKey=" + this.getRequest().getBannerSearchRequest().getSearchKey() +"&"+
               "language="+ this.getRequest().getBannerSearchRequest().getLanguage() +"&"+
               "type="+ this.getRequest().getBannerSearchRequest().getType() +"&"+
               "pageNo="+ this.getRequest().getBannerSearchRequest().getPageNumber() +"&"+
               "pagePerCount="+ this.getRequest().getBannerSearchRequest().getPagePerCount();
    } */
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/bannersearch/bannersearchapi.tsx